import { render, staticRenderFns } from "./runPoint.vue?vue&type=template&id=72dae5d2&scoped=true&"
import script from "./runPoint.vue?vue&type=script&lang=js&"
export * from "./runPoint.vue?vue&type=script&lang=js&"
import style0 from "./runPoint.vue?vue&type=style&index=0&id=72dae5d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dae5d2",
  null
  
)

export default component.exports